export default {
  'pages.layouts.userLayout.title':
    'Ant Designは、西湖区で最も影響力のあるWebデザイン仕様です。',
  'pages.login.accountLogin.tab': 'アカウントログイン',
  'pages.login.accountLogin.errorMessage':
    'ユーザー名/パスワードが正しくありません(admin/ant.design)',
  'pages.login.failure': 'ログインに失敗したら、もう一度試してください!',
  'pages.login.success': 'ログイン成功!',
  'pages.login.username.placeholder': 'ユーザー名：adminまたはuser',
  'pages.login.username.required': 'ユーザー名を入力してください！',
  'pages.login.password.placeholder': 'パスワード：ant.design',
  'pages.login.password.required': 'パスワードを入力してください！',
  'pages.login.phoneLogin.tab': '電話ログイン',
  'pages.login.phoneLogin.errorMessage': '検証コードエラー',
  'pages.login.phoneNumber.placeholder': '電話番号',
  'pages.login.phoneNumber.required': '電話番号を入力してください！',
  'pages.login.phoneNumber.invalid': '電話番号が無効です！',
  'pages.login.captcha.placeholder': '確認コード',
  'pages.login.captcha.required': '確認コードを入力してください！',
  'pages.login.phoneLogin.getVerificationCode': '確認コードを取得',
  'pages.getCaptchaSecondText': '秒',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.forgotPassword': 'パスワードをお忘れですか？',
  'pages.login.submit': 'ログイン',
  'pages.login.loginWith': 'その他のログイン方法：',
  'pages.login.registerAccount': 'アカウント登録',
  'pages.welcome.link': 'ようこそ',
  'pages.welcome.alertMessage':
    'より高速で強力な頑丈なコンポーネントがリリースされました。',
  'pages.404.subTitle':
    '申し訳ありませんが、アクセスしたページは存在しません。',
  'pages.404.buttonText': 'ホームに戻る',
  'pages.admin.subPage.title': 'このページは管理者のみが表示できます',
  'pages.admin.subPage.alertMessage':
    'Umi uiがリリースされました。npm run uiを使用して体験してください。',
  'pages.searchTable.createForm.newRule': '新しいルール',
  'pages.searchTable.updateForm.ruleConfig': 'ルール構成',
  'pages.searchTable.updateForm.basicConfig': '基本情報',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'ルール名',
  'pages.searchTable.updateForm.ruleName.nameRules':
    'ルール名を入力してください！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'ルールの説明',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    '5文字以上入力してください',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    '5文字以上のルールの説明を入力してください！',
  'pages.searchTable.updateForm.ruleProps.title': 'プロパティの構成',
  'pages.searchTable.updateForm.object': '監視対象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'ルールテンプレート',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'ルールタイプ',
  'pages.searchTable.updateForm.schedulingPeriod.title':
    'スケジュール期間の設定',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '開始時間',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    '開始時間を選択してください！',
  'pages.searchTable.titleDesc': '説明',
  'pages.searchTable.ruleName': 'ルール名が必要です',
  'pages.searchTable.titleCallNo': 'サービスコール数',
  'pages.searchTable.titleStatus': 'ステータス',
  'pages.searchTable.nameStatus.default': 'デフォルト',
  'pages.searchTable.nameStatus.running': '起動中',
  'pages.searchTable.nameStatus.online': 'オンライン',
  'pages.searchTable.nameStatus.abnormal': '異常',
  'pages.searchTable.titleUpdatedAt': '最終スケジュール',
  'pages.searchTable.exception': '例外の理由を入力してください！',
  'pages.searchTable.titleOption': 'オプション',
  'pages.searchTable.config': '構成',
  'pages.searchTable.subscribeAlert': 'アラートを購読する',
  'pages.searchTable.title': 'お問い合わせフォーム',
  'pages.searchTable.new': '新しい',
  'pages.searchTable.chosen': '選んだ項目',
  'pages.searchTable.item': '項目',
  'pages.searchTable.totalServiceCalls': 'サービスコールの総数',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.batchDeletion': 'バッチ削除',
  'pages.searchTable.batchApproval': 'バッチ承認',
  'pages.searchTable.selectToDelete': '削除する項目を選択してください',

  'pages.403.subTitle': 'このページにアクセスする権限がありません。',
  'pages.403.buttonText': 'ホームへ戻る',

  // タスク関連フィールド
  'pages.task.owner': '所有者',
  'pages.task.propertyCert': '所有権証書番号',
  'pages.task.region': '都道府県/市区町村',
  'pages.task.cardAddress': '登録住所',
  'pages.task.houseUsage': '登録建物用途',
  'pages.task.landUsage': '登録土地用途',
  'pages.task.houseRightNature': '登録建物権利性質',
  'pages.task.landRightNature': '登録土地権利性質',
  'pages.task.houseRightType': '登録建物権利タイプ',
  'pages.task.landRightType': '登録土地権利タイプ',
  'pages.task.landExpiry': '土地使用権終了日',
  'pages.task.building': '建物名',
  'pages.task.buildingNo': '棟番号',
  'pages.task.unitNo': 'ユニット番号',
  'pages.task.householdNo': '戸番号',
  'pages.task.bedroom': '寝室',
  'pages.task.hall': 'リビング',
  'pages.task.kitchen': 'キッチン',
  'pages.task.toilet': 'トイレ',
  'pages.task.buildingArea': '建物面積(㎡)',
  'pages.task.sharedLandArea': '共有土地面積(㎡)',
  'pages.task.sharedBuildingArea': '共有建物面積(㎡)',
  'pages.task.landArea': '土地使用権面積(㎡)',
  'pages.task.innerArea': '専有面積(㎡)',
  'pages.task.actualUsedType': '実際の用途',
  'pages.task.usageStatus': '使用状況',
  'pages.task.floorPosition': '所在階',
  'pages.task.totalFloors': '総階数',
  'pages.task.finishTime': '竣工年',
  'pages.task.purchaseDuration': '購入年数',
  'pages.task.taxPolicy': '税務政策',
  'pages.task.shopsType': '店舗タイプ',
  'pages.task.shopsAmount': '店舗賃料(元/月)',
  'pages.task.coOwnership': '共有者',
  'pages.task.coOwnershipCircumstance': '共有状況',
  'pages.task.ownershipInfo': '所有権情報',
  'pages.task.smartRecognition': 'スマート認識',
  'pages.task.smartCalculation': 'スマート計算',
  'pages.task.comparativeData': '比較データ',
  'pages.task.calculationTable': '計算表',
  'pages.task.downloadReportPDF': 'レポートPDFをダウンロード',
  'pages.task.viewReport': 'レポートを表示',
  'pages.task.review.totalAmountPrecision': '総額表示精度',
  'pages.task.review.precisionOnes': '一の位',
  'pages.task.review.precisionTens': '十の位',
  'pages.task.review.precisionHundreds': '百の位',
  'pages.task.review.precisionThousands': '千の位',
  'pages.task.review.precisionTenThousands': '万の位',
  'pages.task.review.precisionHundredThousands': '十万の位',
  'pages.task.review.precisionMillions': '百万の位',
  'pages.task.review.savePrecisionFail': '総額精度の保存に失敗しました',
  'pages.netValueSolution.customParams.button': 'カスタムパラメータ',
  'pages.netValueSolution.customParams.title': 'カスタムパラメータ',
  'pages.netValueSolution.customParams.back': '戻る',
  'pages.netValueSolution.customParams.col.name': '表示名',
  'pages.netValueSolution.customParams.col.paramKey': '業務キー',
  'pages.netValueSolution.customParams.col.paramValue': '値',
  'pages.netValueSolution.customParams.col.order': '並び順',
  'pages.netValueSolution.customParams.col.action': '操作',
  'pages.netValueSolution.customParams.col.deductionItem': '控除項目',
  'pages.netValueSolution.customParams.col.calcCondition': '計算条件',
  'pages.netValueSolution.customParams.col.calcFormula': '計算式',
  'pages.netValueSolution.customParams.action.edit': '編集',
  'pages.netValueSolution.customParams.action.delete': '削除',
  'pages.netValueSolution.planDetailLoading': 'プラン詳細を読み込み中…',
  'pages.netValueSolution.customParams.missingPlanId': 'プラン情報がありません。一覧に戻ります。',
  'pages.netValueSolution.customParams.needSavedPlan': '先にプランを保存してからカスタムパラメータを設定してください。',
  'pages.netValueSolution.customParams.addButton': 'カスタムパラメータを追加',
  'pages.netValueSolution.customParams.modalAddTitle': 'カスタムパラメータを追加',
  'pages.netValueSolution.customParams.modalEditTitle': 'カスタムパラメータを編集',
  'pages.netValueSolution.customParams.confirmDelete': 'このカスタムパラメータを削除しますか？',
  'pages.netValueSolution.customParams.loadListFailed': '読み込みに失敗しました',
  'pages.netValueSolution.customParams.saveSuccess': '保存しました',
  'pages.netValueSolution.customParams.saveFailed': '保存に失敗しました',
  'pages.netValueSolution.customParams.saving': '保存中…',
  'pages.netValueSolution.customParams.loadingDetail': '詳細を読み込み中…',
  'pages.netValueSolution.customParams.loadDetailFailed': '詳細の読み込みに失敗しました',
  'pages.netValueSolution.customParams.deleteSuccess': '削除しました',
  'pages.netValueSolution.customParams.deleteFailed': '削除に失敗しました',
  'pages.netValueSolution.customParams.rules.name': '表示名を入力してください',
  'pages.netValueSolution.customParams.rules.paramKey': '業務キーを入力してください',
  'pages.netValueSolution.customParams.rules.orderIndex': '並び順を入力してください',
  'pages.netValueSolution.deduction.modalAdd': '控除項目を追加',
  'pages.netValueSolution.deduction.modalEdit': '控除項目を編集',
  'pages.netValueSolution.deduction.modalAddTaxRate': '税率を追加',
  'pages.netValueSolution.table.confirmDelete': 'この行を削除しますか？',
  'pages.netValueSolution.table.confirmDeleteWithChildren':
    'この行を削除しますか？関連する子行も削除されます。',
  'pages.netValueSolution.formulaConfig.title': '計算式の設定',
  'pages.netValueSolution.add.pageTitle': 'プランを追加',
  'pages.netValueSolution.edit.pageTitle': 'プランを編集',
  'pages.netValueSolution.taxCard.title': '税費控除項目',
  'pages.netValueSolution.conditionRequired': '計算条件を1つ以上選択してください',
  'pages.netValueSolution.taxModal.deductionNameRequired': '控除項目名を入力してください',
  'pages.netValueSolution.taxModal.childConditionRequired':
    '子項目では、少なくとも1つの計算条件を選択または入力してから保存してください',
  'pages.netValueSolution.taxModal.formulaRequired':
    '保存する前に計算式を設定してください',
  'pages.netValueSolution.message.savePlanSuccess': 'プランを保存しました',
  'pages.netValueSolution.message.addDeductionSuccess': '控除項目を追加しました',
  'pages.netValueSolution.message.loadDetailFailed': 'プラン詳細の読み込みに失敗しました',
  'pages.netValueSolution.message.defaultItemCannotDelete': 'デフォルトの増減項目は削除できません',
  'pages.netValueSolution.message.taxRateMax100': '税率は100を超えられません',
  'pages.netValueSolution.message.dataAbnormalRetry': 'データ異常です。閉じて再度お試しください',
  'pages.netValueSolution.message.updateTaxRateSuccess': '税率を更新しました',
  'pages.netValueSolution.message.addTaxRateSuccess': '税率を追加しました',
  'pages.netValueSolution.message.checkRequiredFieldsEmpty': '必須項目を入力してください',
  'pages.netValueSolution.message.checkRequiredFieldsWithDetails': '次の必須項目を確認してください：{details}',
  'pages.netValueSolution.message.selectAtLeastOneDeduction': '送信するには控除項目を1件以上選択してください',
  'pages.netValueSolution.message.unknownField': '不明な項目',
  'pages.netValueSolution.addForm.label.cityName': '対象都市',
  'pages.netValueSolution.addForm.label.provinceCode': '対象省',
  'pages.netValueSolution.addForm.label.bankId': '対象銀行',
  'pages.netValueSolution.addForm.label.businessLines': '事業領域',
  'pages.netValueSolution.addForm.label.businessType': '業務種別',
  'pages.netValueSolution.addForm.label.netWorthName': '抵当純資産',
  'pages.netValueSolution.addForm.label.organizationId': '対象組織',
  'pages.netValueSolution.addForm.rules.selectCity': '対象都市を選択してください',
  'pages.netValueSolution.addForm.rules.selectProvince': '省を選択してください',
  'pages.netValueSolution.addForm.rules.selectBank': '対象銀行を選択してください',
  'pages.netValueSolution.addForm.rules.selectBusinessLines': '事業領域を選択してください',
  'pages.netValueSolution.addForm.rules.selectBusinessType': '業務種別を選択してください',
  'pages.netValueSolution.addForm.rules.selectNetWorth': '抵当純資産を選択してください',
  'pages.netValueSolution.addForm.rules.selectOrganization': '対象組織を選択してください',
  'pages.netValueSolution.addForm.placeholder.selectProvince': '省を選択',
  'pages.netValueSolution.addForm.placeholder.selectCity': '都市を選択',
  'pages.netValueSolution.addForm.placeholder.selectBank': '対象銀行を選択',
  'pages.netValueSolution.addForm.placeholder.selectBusinessLines': '事業領域を選択',
  'pages.netValueSolution.addForm.placeholder.selectBusinessType': '業務種別を選択',
  'pages.netValueSolution.addForm.placeholder.selectNetWorth': '抵当純資産を選択',
  'pages.netValueSolution.addForm.placeholder.selectOrganization': '対象組織を選択',
  'pages.netValueSolution.addForm.alertLine1':
    'デフォルトはシステムの計算方式です。ユーザー設定に合わない場合は、システムのデフォルトで税額を計算します。',
  'pages.netValueSolution.addForm.alertLine2':
    '税費控除ではカスタム控除項目を追加でき、計算はデフォルト方式です。',
  'pages.netValueSolution.addForm.alertLine3':
    '税項目リストの追加では、該当税目の複数シナリオの税率を追加します。',
  'pages.netValueSolution.addNewDeduction': '控除項目を追加',

  'pages.netValueSolution.list.title': '純資産プラン',
  'pages.netValueSolution.list.addButton': 'プランを追加',
  'pages.netValueSolution.list.loadListFailed': '一覧の読み込みに失敗しました',
  'pages.netValueSolution.list.loadListFailedRetry': '一覧の読み込みに失敗しました。再試行してください。',
  'pages.netValueSolution.list.missingPlanId': 'プラン ID を取得できません',
  'pages.netValueSolution.list.confirmDeleteTitle': '削除の確認',
  'pages.netValueSolution.list.confirmDeleteContent':
    '削除すると元に戻せません。このプランを削除しますか？',
  'pages.netValueSolution.list.deleteItemLabel': 'プラン「{name}」',
  'pages.netValueSolution.list.edit': '編集',
  'pages.netValueSolution.list.copy': 'コピー',
  'pages.netValueSolution.list.col.province': '対象省',
  'pages.netValueSolution.list.col.city': '対象市',
  'pages.netValueSolution.list.col.bank': '対象銀行',
  'pages.netValueSolution.list.col.businessLines': '事業領域',
  'pages.netValueSolution.list.col.businessType': '業務種別',
  'pages.netValueSolution.list.col.organization': '所属組織',
  'pages.netValueSolution.list.col.netWorthName': '純資産名',
  'pages.netValueSolution.list.col.deductItems': '税費控除',
  'pages.netValueSolution.list.col.action': '操作',
  'pages.netValueSolution.list.ph.province': '省を選択',
  'pages.netValueSolution.list.ph.city': '市を選択',
  'pages.netValueSolution.list.ph.bank': '銀行を選択',
  'pages.netValueSolution.list.ph.businessLines': '事業領域を選択',
  'pages.netValueSolution.list.ph.businessType': '業務種別を選択',
  'pages.netValueSolution.list.ph.organization': '組織を選択',
  'pages.netValueSolution.list.ph.netWorthName': '純資産名を選択',
  'pages.netValueSolution.list.paginationTotal': '{total} 件中 {start}-{end} 件',

  'pages.universalParams.title': '汎用パラメータ',
  'pages.universalParams.addButton': 'パラメータを追加',
  'pages.universalParams.col.orderIndex': '並び順',
  'pages.universalParams.col.name': '名前',
  'pages.universalParams.col.description': '説明',
  'pages.universalParams.col.value': '値',
  'pages.universalParams.col.action': '操作',
  'pages.universalParams.loadListFailed': '一覧の読み込みに失敗しました',
  'pages.universalParams.loadDetailFailed': '詳細の読み込みに失敗しました',
  'pages.universalParams.confirmDeleteTitle': '削除の確認',
  'pages.universalParams.confirmDeleteDesc': 'パラメータ「{name}」を削除しますか？',
  'pages.universalParams.modal.addTitle': '汎用パラメータを追加',
  'pages.universalParams.modal.editTitle': '汎用パラメータを編集',
  'pages.universalParams.form.name': '名前',
  'pages.universalParams.form.namePlaceholder': '表示名',
  'pages.universalParams.form.description': '説明',
  'pages.universalParams.form.descriptionPlaceholder': '任意',
  'pages.universalParams.form.value': '値（value）',
  'pages.universalParams.form.valuePlaceholder': 'tb_task_record.appraisal_value',
  'pages.universalParams.form.orderIndex': '並び順',
  'pages.universalParams.form.orderPlaceholder': '小さいほど上に表示',
  'pages.universalParams.rules.nameRequired': '名前を入力してください',
  'pages.universalParams.rules.valueRequired': '値を入力してください',
  'pages.universalParams.rules.valueFormat':
    'tb_テーブル.フィールド（小文字とアンダースコア）形式、例 tb_task_record.appraisal_value',
  'pages.universalParams.extra.valueHint':
    '式の PARAM キーは tb_ 接頭辞のテーブル.フィールドと一致させます（例 tb_task_record.value）',

  'pages.system.logs.headerTitle': 'Operation logs',
  'pages.system.logs.col.modelName': 'Module',
  'pages.system.logs.col.apiName': 'Content',
  'pages.system.logs.col.userName': 'Operator',
  'pages.system.logs.col.requestIp': 'Request IP',
  'pages.system.logs.col.status': 'Status',
  'pages.system.logs.col.createTime': 'Time',
  'pages.system.logs.col.timeRange': 'Time range',
  'pages.system.logs.ph.module': 'Select module',
  'pages.system.logs.ph.userName': 'Enter operator name',
  'pages.system.logs.fetchModulesFailed': 'Failed to load operation modules',
  'pages.system.permission.addButton': 'Add permission',
  'pages.system.permission.col.name': 'Permission name',
  'pages.system.permission.col.desc': 'Description',
  'pages.system.permission.col.action': 'Actions',
  'pages.system.permission.configureApi': 'Configure API',
  'pages.system.permission.deleteItemName': 'Permission “{name}”',
  'pages.system.permission.batchSelected': '{count} permission(s) selected',
  'pages.system.permission.apiConfigSuccess': 'API permissions saved',
  'pages.system.permission.apiConfigFailed': 'Failed to save API permissions',
  'pages.system.permission.apiConfigFailedRetry': 'Failed to save API permissions. Please try again.',
  'pages.system.permission.apiModalTitle': 'Configure API permissions - {name}',
  'pages.system.permission.selectToDelete': 'Select permissions to delete',
  'pages.system.role.col.name': 'Role name',
  'pages.system.role.col.description': 'Description',
  'pages.system.role.col.action': 'Actions',
  'pages.system.role.deleteItemName': 'Role [{name}]',
  'pages.system.role.batchSelected': '{count} role(s) selected',
  'pages.system.role.configurePermission': 'Configure permissions',
  'pages.system.role.configureMenuPermission': 'Configure menu permissions',
  'pages.system.role.apiConfigSuccess': 'API permissions saved',
  'pages.system.role.permissionConfigSuccess': 'Permissions saved',
  'pages.system.role.menuPermissionConfigSuccess': 'Menu permissions saved',
  'pages.system.role.deleteFailedCount': '{count} role(s) failed to delete',
  'pages.system.menu.col.name': 'Name',
  'pages.system.menu.col.code': 'Code',
  'pages.system.menu.col.action': 'Actions',
  'pages.system.menu.addButton': 'Add menu',
  'pages.system.menu.addSubMenu': 'Add sub-menu',
  'pages.system.menu.deleteItemName': 'Menu “{name}”',

  'pages.system.dept.pageTitle': 'Departments',
  'pages.system.dept.refresh': 'Refresh',
  'pages.system.dept.addDept': 'Add department',
  'pages.system.dept.addChildDept': 'Add sub-department',
  'pages.system.dept.editDept': 'Edit department',
  'pages.system.dept.treeTitle': 'Department tree',
  'pages.system.dept.orgCount': '{count} organization(s)',
  'pages.system.dept.emptyTree': 'No department data',
  'pages.system.dept.detailDept': 'Department details',
  'pages.system.dept.detailOrg': 'Organization details',
  'pages.system.dept.edit': 'Edit',
  'pages.system.dept.delete': 'Delete',
  'pages.system.dept.label.deptName': 'Department name',
  'pages.system.dept.label.deptId': 'Department ID',
  'pages.system.dept.label.parentDept': 'Parent department',
  'pages.system.dept.label.status': 'Status',
  'pages.system.dept.label.childCount': 'Sub-departments',
  'pages.system.dept.label.ownerOrg': 'Organization / customer',
  'pages.system.dept.label.orgName': 'Organization / customer name',
  'pages.system.dept.label.orgId': 'Organization / customer ID',
  'pages.system.dept.label.ownerType': 'Type',
  'pages.system.dept.type.organization': 'Organization',
  'pages.system.dept.type.customer': 'Customer',
  'pages.system.dept.status.enabled': 'Enabled',
  'pages.system.dept.status.disabled': 'Disabled',
  'pages.system.dept.parentRoot': 'None (root)',
  'pages.system.dept.selectNodeHint': 'Select a department or organization on the left',
  'pages.system.dept.unnamedDept': 'Unnamed department',
  'pages.system.dept.ungrouped': 'Ungrouped',
  'pages.system.dept.unnamed': 'Unnamed',
  'pages.system.dept.fetchTreeFail': 'Failed to load department tree',
  'pages.system.dept.fetchTreeFailRetry': 'Failed to load department tree. Please try again later.',
  'pages.system.dept.cannotDeleteInvalid': 'Cannot delete an invalid department node',
  'pages.system.dept.cannotDeleteRoot': 'Root department cannot be deleted',
  'pages.system.dept.defaultItemName': 'department',
  'pages.system.dept.deleteTitle': 'Delete this department?',
  'pages.system.dept.deleteContent':
    'This cannot be undone. Sub-departments under it will be affected.',
  'pages.system.dept.deleteSuccess': 'Deleted',
  'pages.system.dept.deleteFail': 'Delete failed',
  'pages.system.dept.deleteFailRetry': 'Delete failed. Please try again.',
  'pages.system.dept.editMissingOwner': 'Missing organization/customer for this department. Refresh and try again.',
  'pages.system.dept.saveSuccessEdit': 'Department updated',
  'pages.system.dept.saveSuccessAdd': 'Department created',
  'pages.system.dept.saveFail': 'Save failed',
  'pages.system.dept.form.name': 'Department name',
  'pages.system.dept.form.nameRequired': 'Enter department name',
  'pages.system.dept.form.nameMax': 'Name must be 50 characters or less',
  'pages.system.dept.form.namePlaceholder': 'Enter department name',
  'pages.system.dept.form.ownerOrg': 'Organization',
  'pages.system.dept.form.ownerOrgRequired': 'Select an organization',
  'pages.system.dept.form.ownerOrgPlaceholder': 'Select an organization',
  'pages.system.dept.form.ownerOrgCustomer': 'Organization / customer',
  'pages.system.dept.form.ownerSelectedPlaceholder': 'Selected organization / customer',
  'pages.system.dept.form.parentDept': 'Parent department',
  'pages.system.dept.form.parentDeptPlaceholder': 'Select parent department',

  'pages.operations.statTotalCustomers': 'Total customers',
  'pages.operations.statNewThisMonth': 'New this month',
  'pages.operations.statPendingTasks': 'Pending tasks',
  'pages.operations.statReportsDone': 'Reports completed',
  'pages.operations.taskRateTitle': 'Task completion',
  'pages.operations.recentActivityTitle': 'Recent activity',
  'pages.operations.col.time': 'Time',
  'pages.operations.col.activity': 'Activity',
  'pages.operations.col.operator': 'Operator',
  'pages.operations.col.status': 'Status',
  'pages.operations.taskName.evaluation': 'Customer evaluation',
  'pages.operations.taskName.report': 'Report generation',
  'pages.operations.taskName.finance': 'Finance review',
  'pages.operations.taskName.maintenance': 'System maintenance',
  'pages.operations.status.done': 'Done',
  'pages.operations.status.inProgress': 'In progress',
  'pages.operations.systemStatusTitle': 'System status',
  'pages.operations.cpuUsage': 'CPU usage',
  'pages.operations.memoryUsage': 'Memory usage',
  'pages.operations.diskUsage': 'Disk usage',
  'pages.operations.demo.action1': 'New customer evaluation task',
  'pages.operations.demo.action2': 'Finance report review completed',
  'pages.operations.demo.action3': 'System maintenance update',
  'pages.operations.demo.action4': 'Customer satisfaction survey',
  'pages.operations.demo.user1': 'Zhang',
  'pages.operations.demo.user2': 'Li',
  'pages.operations.demo.user3': 'Wang',
  'pages.operations.demo.user4': 'Zhao',
  'pages.finance.tooltip.view': 'View',
  'pages.finance.tooltip.edit': 'Edit',
  'pages.finance.tooltip.delete': 'Delete',
  'pages.finance.stat.totalIncome': 'Total income',
  'pages.finance.stat.totalExpense': 'Total expense',
  'pages.finance.stat.netIncome': 'Net income',
  'pages.finance.modal.add': 'Add finance record',
  'pages.finance.modal.edit': 'Edit finance record',
  'pages.finance.addRecord': 'Add record',
  'pages.finance.paginationTotal': 'Items {start}-{end} of {total}',
  'pages.platform.tooltip.view': 'View',
  'pages.platform.tooltip.edit': 'Edit',
  'pages.platform.tooltip.delete': 'Delete',
  'pages.platform.modal.add': 'Add maintenance record',
  'pages.platform.modal.edit': 'Edit maintenance record',
  'pages.platform.addRecord': 'Add maintenance',
  'pages.platform.paginationTotal': '{total} records',
  'pages.platform.column.id': 'ID',
  'pages.platform.column.title': 'Title',
  'pages.platform.column.type': 'Type',
  'pages.platform.column.priority': 'Priority',
  'pages.platform.column.status': 'Status',
  'pages.platform.column.progress': 'Progress',
  'pages.platform.column.assignee': 'Assignee',
  'pages.platform.column.createTime': 'Created',
  'pages.platform.column.estimatedTime': 'Est. completion',
  'pages.platform.column.action': 'Actions',
  'pages.platform.overview.ok': 'System OK',
  'pages.platform.overview.running': 'Running',
  'pages.platform.overview.attention': 'Attention',
  'pages.platform.overview.error': 'Error',
  'pages.platform.alert.title': 'System status',
  'pages.platform.alert.cpu': 'CPU',
  'pages.platform.alert.memory': 'Memory',
  'pages.platform.alert.disk': 'Disk',
  'pages.platform.alert.network': 'Network',
  'pages.platform.alert.networkOk': 'OK',
  'pages.platform.filter.searchPlaceholder': 'Search title or description',
  'pages.platform.filter.typePlaceholder': 'Type',
  'pages.platform.filter.statusPlaceholder': 'Status',
  'pages.platform.filter.priorityPlaceholder': 'Priority',
  'pages.platform.filter.assigneePlaceholder': 'Filter by assignee',
  'pages.platform.type.all': 'All types',
  'pages.platform.type.performance': 'Performance',
  'pages.platform.type.security': 'Security',
  'pages.platform.type.hardware': 'Hardware',
  'pages.platform.status.all': 'All statuses',
  'pages.platform.status.pending': 'Pending',
  'pages.platform.status.ongoing': 'In progress',
  'pages.platform.status.completed': 'Completed',
  'pages.platform.priority.all': 'All priorities',
  'pages.platform.priority.high': 'High',
  'pages.platform.priority.medium': 'Medium',
  'pages.platform.priority.low': 'Low',
  'pages.platform.stat.total': 'Total records',
  'pages.platform.stat.completed': 'Completed',
  'pages.platform.stat.inProgress': 'In progress',
  'pages.platform.stat.pending': 'Pending',
  'pages.platform.confirmDelete': 'Confirm delete',
  'pages.platform.confirmDeleteContent': 'Delete maintenance record "{title}"?',
  'pages.platform.msg.deleteSuccess': 'Deleted',
  'pages.platform.msg.updateSuccess': 'Updated',
  'pages.platform.msg.addSuccess': 'Added',
  'pages.platform.form.title': 'Title',
  'pages.platform.form.titleRequired': 'Enter title',
  'pages.platform.form.titlePlaceholder': 'Enter title',
  'pages.platform.form.type': 'Type',
  'pages.platform.form.typeRequired': 'Select type',
  'pages.platform.form.typePerformance': 'Performance',
  'pages.platform.form.typeSecurity': 'Security',
  'pages.platform.form.typeHardware': 'Hardware',
  'pages.platform.form.typeSoftware': 'Software update',
  'pages.platform.form.priority': 'Priority',
  'pages.platform.form.priorityRequired': 'Select priority',
  'pages.platform.form.assignee': 'Assignee',
  'pages.platform.form.assigneeRequired': 'Enter assignee',
  'pages.platform.form.assigneePlaceholder': 'Enter assignee',
  'pages.platform.form.estimatedTime': 'Est. completion',
  'pages.platform.form.estimatedTimeRequired': 'Select date',
  'pages.platform.form.estimatedTimePlaceholder': 'e.g. 2024-01-20',
  'pages.platform.form.description': 'Description',
  'pages.platform.form.descriptionRequired': 'Enter description',
  'pages.platform.form.descriptionPlaceholder': 'Enter description',
  'pages.platform.form.status': 'Status',
  'pages.activity.tooltip.view': 'View',
  'pages.activity.tooltip.edit': 'Edit',
  'pages.activity.tooltip.delete': 'Delete',
  'pages.activity.modal.add': 'Add activity',
  'pages.activity.modal.edit': 'Edit activity',
  'pages.activity.addRecord': 'Add activity',
  'pages.activity.paginationTotal': '{total} records',
  'pages.activity.column.id': 'Activity ID',
  'pages.activity.column.title': 'Title',
  'pages.activity.column.type': 'Type',
  'pages.activity.column.startTime': 'Start time',
  'pages.activity.column.endTime': 'End time',
  'pages.activity.column.location': 'Location',
  'pages.activity.column.status': 'Status',
  'pages.activity.column.participants': 'Participants',
  'pages.activity.column.budget': 'Budget',
  'pages.activity.column.organizer': 'Organizer',
  'pages.activity.column.action': 'Actions',
  'pages.activity.stat.total': 'Total activities',
  'pages.activity.stat.inProgress': 'In progress',
  'pages.activity.stat.registering': 'Registration open',
  'pages.activity.stat.ended': 'Ended',
  'pages.activity.filter.searchPlaceholder': 'Search by title or organizer',
  'pages.activity.filter.typePlaceholder': 'Type',
  'pages.activity.filter.statusPlaceholder': 'Status',
  'pages.activity.filter.locationPlaceholder': 'Filter by location',
  'pages.activity.type.all': 'All types',
  'pages.activity.type.customer': 'Customer event',
  'pages.activity.type.training': 'Training',
  'pages.activity.type.meeting': 'Internal meeting',
  'pages.activity.status.all': 'All statuses',
  'pages.activity.status.planning': 'Planning',
  'pages.activity.status.registration': 'Registration open',
  'pages.activity.status.ongoing': 'In progress',
  'pages.activity.status.ended': 'Ended',
  'pages.activity.rangeStart': 'Start date',
  'pages.activity.rangeEnd': 'End date',
  'pages.activity.confirmDelete': 'Confirm delete',
  'pages.activity.confirmDeleteContent': 'Delete activity "{title}"?',
  'pages.activity.msg.deleteSuccess': 'Deleted',
  'pages.activity.msg.updateSuccess': 'Updated',
  'pages.activity.msg.addSuccess': 'Added',
  'pages.activity.form.title': 'Title',
  'pages.activity.form.titleRequired': 'Enter title',
  'pages.activity.form.titlePlaceholder': 'Enter title',
  'pages.activity.form.type': 'Type',
  'pages.activity.form.typeRequired': 'Select type',
  'pages.activity.form.organizer': 'Organizer',
  'pages.activity.form.organizerRequired': 'Enter organizer',
  'pages.activity.form.organizerPlaceholder': 'Enter organizer',
  'pages.activity.form.startTime': 'Start time',
  'pages.activity.form.startTimeRequired': 'Select start time',
  'pages.activity.form.endTime': 'End time',
  'pages.activity.form.endTimeRequired': 'Select end time',
  'pages.activity.form.location': 'Location',
  'pages.activity.form.locationRequired': 'Enter location',
  'pages.activity.form.locationPlaceholder': 'Enter location',
  'pages.activity.form.maxParticipants': 'Max participants',
  'pages.activity.form.maxParticipantsRequired': 'Enter max participants',
  'pages.activity.form.budget': 'Budget',
  'pages.activity.form.budgetRequired': 'Enter budget',
  'pages.activity.form.activityStatus': 'Status',

  'pages.customer.list.col.customerName': 'Customer name',
  'pages.customer.list.col.customerType': 'Customer type',
  'pages.customer.list.col.province': 'Province',
  'pages.customer.list.col.city': 'City',
  'pages.customer.list.col.district': 'District',
  'pages.customer.list.col.organization': 'Organization',
  'pages.customer.list.col.status': 'Status',
  'pages.customer.list.col.contact': 'Contacts',
  'pages.customer.list.col.contactPhone': 'Contact phone',
  'pages.customer.list.col.createTime': 'Created at',
  'pages.customer.list.col.updateTime': 'Updated at',
  'pages.customer.list.col.action': 'Actions',
  'pages.customer.list.confirmToggleTitle': 'Confirm {action}',
  'pages.customer.list.confirmToggleContent': 'Are you sure you want to {action} this customer?',
  'pages.customer.list.itemNamed': 'Customer "{name}"',
  'pages.customer.list.batchItemName': '{count} selected customer(s)',
  'pages.customer.list.batchContent':
    'This cannot be undone. Delete the selected customers?',
  'pages.customer.list.batchResultAllSuccess': 'Deleted {success} customer(s)',
  'pages.customer.list.batchResultPartial': 'Deleted {success} customer(s), {fail} failed',
  'pages.customer.list.batchFailed': 'Batch delete failed',
  'pages.customer.list.exportOrgTemplate': 'Organization customer template',
  'pages.customer.list.exportPersonalTemplate': 'Individual customer template',
  'pages.customer.list.exportUserTemplate': 'Customer user template',
  'pages.customer.list.exportTemplate': 'Download template',
  'pages.customer.list.importCustomer': 'Import customers',
  'pages.customer.list.importCustomerUser': 'Import customer users',
  'pages.customer.list.addCustomer': 'Add customer',
  'pages.customer.list.fileNameOrgTemplate': 'organization-customer-import.xlsx',
  'pages.customer.list.fileNamePersonalTemplate': 'personal-customer-import.xlsx',
  'pages.customer.list.fileNameUserTemplate': 'customer-user-import.xlsx',
  'pages.customer.list.deleteContent':
    'This cannot be undone. Delete this customer?',
  'pages.customer.list.toggleSuccess': '{action} succeeded',
  'pages.customer.list.toggleFail': '{action} failed',
  'pages.taskMgmt.col.taskNumber': 'Task number',
  'pages.taskMgmt.col.reportNumber': 'Report number',
  'pages.taskMgmt.col.taskName': 'Task name',
  'pages.taskMgmt.col.specialSituation': 'Special situation',
  'pages.taskMgmt.col.taskStatus': 'Task status',
  'pages.taskMgmt.col.creator': 'Creator',
  'pages.taskMgmt.col.currentOperator': 'Current operator',
  'pages.taskMgmt.col.province': 'Province',
  'pages.taskMgmt.col.city': 'City',
  'pages.taskMgmt.col.district': 'District',
  'pages.taskMgmt.col.createTime': 'Created at',
  'pages.taskMgmt.col.action': 'Actions',
  'pages.taskMgmt.action.view': 'View',
  'pages.taskMgmt.action.edit': 'Edit',
  'pages.taskMgmt.action.withdraw': 'Withdraw',
  'pages.taskMgmt.withdrawTitle': 'Withdraw price review',
  'pages.taskMgmt.withdrawConfirm': 'Confirm withdraw',
  'pages.taskMgmt.withdrawSuccess': 'Price review withdrawn',
  'pages.taskMgmt.withdrawCheckFail': 'Failed to check withdraw eligibility',
  'pages.taskMgmt.withdrawCheckFailRetry': 'Failed to check withdraw eligibility. Please try again.',
  'pages.taskMgmt.withdrawFail': 'Failed to withdraw price review',
  'pages.taskMgmt.withdrawFailRetry': 'Failed to withdraw price review. Please try again.',
  'pages.taskMgmt.withdrawNotAllowedTitle': 'Withdraw not allowed',
  'pages.taskMgmt.withdrawNotAllowedDefault': 'This task cannot withdraw price review in its current state',
  'pages.taskMgmt.withdrawApproverLabel': 'Approver',
  'pages.taskMgmt.withdrawApproverPlaceholder': 'Search by name or select a department manager',
  'pages.taskMgmt.withdrawApproverRequired': 'Please select an approver',
  'pages.taskMgmt.withdrawApproverNotFound': 'No matching approver found',
  'pages.taskMgmt.withdrawCommentLabel': 'Comment',
  'pages.taskMgmt.withdrawCommentPlaceholder': 'Enter withdrawal reason',
  'pages.taskMgmt.withdrawCommentRequired': 'Withdrawal reason is required',
  'pages.taskMgmt.unknownStatus': 'Unknown status',
  'pages.taskMgmt.createLoading': 'Creating task…',
  'pages.taskMgmt.createFail': 'Failed to create task. Please try again.',
  'pages.taskMgmt.deleteTitle': 'Confirm delete',
  'pages.taskMgmt.deleteContent': 'Delete task "{name}"?',
  'pages.taskMgmt.noTaskId': 'Task ID missing; cannot delete',
  'pages.taskMgmt.redoTitle': 'Confirm redo',
  'pages.taskMgmt.redoContent': 'Redo task "{name}"?',
  'pages.taskMgmt.redoSuccess': 'Task redone',
  'pages.taskMgmt.fetchListFail': 'Failed to load task list',
  'pages.taskMgmt.fetchListFailRetry': 'Failed to load task list. Please try again.',
  'pages.taskMgmt.modalAddTitle': 'New task',
  'pages.taskMgmt.formTaskName': 'Task name',
  'pages.taskMgmt.formTaskNameMax': 'Name must be 100 characters or less',
  'pages.taskMgmt.formTaskNamePlaceholder': 'Task name (optional)',
  'pages.taskMgmt.paginationTotal': 'Items {start}-{end} of {total}',
  'pages.report.col.electronicCode': 'Electronic report code',
  'pages.report.col.estimateCode': 'Report number',
  'pages.report.col.taskName': 'Task name',
  'pages.report.col.state': 'Status',
  'pages.report.col.creator': 'Creator',
  'pages.report.col.operator': 'Current operator',
  'pages.report.col.organization': 'Organization',
  'pages.report.col.province': 'Province',
  'pages.report.col.city': 'City',
  'pages.report.col.district': 'District',
  'pages.report.col.createTime': 'Created at',
  'pages.report.col.action': 'Actions',
  'pages.report.state.all': 'All',
  'pages.report.state.pendingFirst': 'First review pending',
  'pages.report.state.pendingSecond': 'Second review pending',
  'pages.report.state.pendingThird': 'Third review pending',
  'pages.report.state.pendingSeal': 'Pending seal',
  'pages.report.state.pendingModify': 'Pending modification',
  'pages.report.state.done': 'Completed',
  'pages.report.state.pendingArchive': 'Pending archive',
  'pages.report.state.void': 'Void',
  'pages.report.state.completedEnd': 'Closed',
  'pages.report.state.pendingReview': 'Pending review',
  'pages.report.state.reviewed': 'Reviewed',
  'pages.report.state.sealPending': 'Pending seal',
  'pages.report.state.sealed': 'Sealed',
  'pages.report.process.pending': 'Pending',
  'pages.report.process.done': 'Processed',
  'pages.report.review.addDev': 'New report feature is under development…',
  'pages.report.action.review': 'Review',
  'pages.report.action.sign': 'Sign',
  'pages.ledger.list.title': 'Ledger records',
  'pages.ledger.list.fetchFail': 'Failed to load ledger list',
  'pages.ledger.list.directConnect': 'Direct connect',
  'pages.ledger.list.tokenRequired': 'Enter third-party platform token',
  'pages.ledger.list.syncFail': 'Sync failed',
  'pages.ledger.list.directConnectDone': 'Direct connect completed',
  'pages.ledger.list.directConnectAlready': 'This ledger already completed direct connect',
  'pages.ledger.list.initFail': 'Initialization failed',
  'pages.ledger.list.initNoFileId': 'Initialization did not return fileId; cannot save binding',
  'pages.ledger.list.saveBindFail': 'Save and bind failed',
  'pages.ledger.list.flowFail': 'Handover review failed',
  'pages.ledger.list.flowTimeout': 'Review workflow timed out. Please try again later.',
  'pages.ledger.list.editDirectFail': 'Edit and direct connect failed',
  'pages.ledger.list.searchConfigSaved': 'Search field configuration saved',
  'pages.ledger.list.ph.province': 'Select province',
  'pages.ledger.list.ph.city': 'Select city',
  'pages.ledger.list.ph.district': 'Select district',
  'pages.ledger.list.ph.street': 'Select street',
  'pages.ledger.list.notFoundData': 'No data',
  'pages.ledger.list.notFoundSelectProvince': 'Select province first',
  'pages.ledger.list.notFoundSelectCity': 'Select city first',
  'pages.ledger.list.notFoundSelectDistrict': 'Select district first',
  'pages.ledger.list.downloadTemplate': 'Downloading template…',
  'pages.ledger.list.templateFileName': 'ledger-import-template.xlsx',
  'pages.ledger.list.exporting': 'Exporting…',
  'pages.ledger.list.exportSuccess': 'Export succeeded',
  'pages.ledger.list.exportFail': 'Export failed',

  'pages.ledger.list.batchDirectConnect': 'Batch direct connect',
  'pages.ledger.list.autoDirectConnect': 'Auto direct connect',
  'pages.ledger.list.batchDirectConnectHint': 'Start batch direct connect for {count} eligible record(s)',
  'pages.ledger.list.autoDirectConnectHint': 'The system will auto-select pending records; scope is determined by the backend',
  'pages.ledger.list.directConnectTokenLabel': 'User token (required)',
  'pages.ledger.list.directConnectFileLabel': 'File (optional; uploaded file takes priority)',
  'pages.ledger.list.directConnectSelectFile': 'Select file',
  'pages.ledger.list.batchDirectConnectSkipped': 'Skipped {count} ineligible record(s)',
  'pages.ledger.list.batchDirectConnectNoEligible': 'No eligible records to connect',
  'pages.ledger.list.batchDirectConnectStartFail': 'Failed to start batch direct connect',
  'pages.ledger.list.autoDirectConnectStartFail': 'Failed to start auto direct connect',
  'pages.ledger.list.directConnectJobTitle': 'Direct connect progress',
  'pages.ledger.list.directConnectJobStatusLabel': 'Job status',
  'pages.ledger.list.directConnectJobTotal': 'Total',
  'pages.ledger.list.directConnectJobSuccess': 'Success',
  'pages.ledger.list.directConnectJobFailed': 'Failed',
  'pages.ledger.list.directConnectJobProcessing': 'In progress',
  'pages.ledger.list.directConnectJobEmpty': 'No details',
  'pages.ledger.list.directConnectJobCompleted': 'Direct connect job completed',
  'pages.ledger.list.directConnectJobFailedMessage': 'Direct connect job failed',
  'pages.ledger.list.directConnectJobQueryFail': 'Failed to query direct connect progress',
  'pages.ledger.list.directConnectJobCloseTitle': 'Job still running',
  'pages.ledger.list.directConnectJobCloseContent': 'The job will continue in the background. Close this window?',
  'pages.ledger.list.directConnectCol.reportNumber': 'Report no.',
  'pages.ledger.list.directConnectCol.electronicReportCode': 'E-report code',
  'pages.ledger.list.directConnectCol.status': 'Status',
  'pages.ledger.list.directConnectCol.stage': 'Stage',
  'pages.ledger.list.directConnectCol.message': 'Message',
  'pages.ledger.list.directConnectJobStatus.RUNNING': 'Running',
  'pages.ledger.list.directConnectJobStatus.COMPLETED': 'Completed',
  'pages.ledger.list.directConnectJobStatus.FAILED': 'Failed',
  'pages.ledger.list.directConnectItemStatus.PENDING': 'Pending',
  'pages.ledger.list.directConnectItemStatus.RUNNING': 'Running',
  'pages.ledger.list.directConnectItemStatus.SUCCESS': 'Success',
  'pages.ledger.list.directConnectItemStatus.FAILED': 'Failed',

  'pages.system.user.col.username': 'Username',
  'pages.system.user.col.workNo': 'Employee ID',
  'pages.system.user.col.realName': 'Name',
  'pages.system.user.ph.realName': 'Search by name',
  'pages.system.user.col.email': 'Email',
  'pages.system.user.col.phone': 'Phone',
  'pages.system.user.selectToDelete': 'Select users to delete',
  'pages.system.user.batchDeleteFail': 'Batch delete failed',
  'pages.system.user.downloadTemplateLoading': 'Downloading template…',
  'pages.system.user.templateFileName': 'user-import-template.xlsx',
  'pages.system.user.templateDownloadSuccess': 'Template downloaded',
  'pages.system.user.templateDownloadFail': 'Download failed. Please try again.',
  'pages.system.user.uploadExcelOnly': 'Please upload an Excel file (.xlsx or .xls)',
  'pages.system.user.fileTooLarge': 'File size must not exceed 10MB',
  'pages.system.user.importDone': 'Import finished',
  'pages.system.user.importFail': 'Import failed',
  'pages.system.user.importFailRetry': 'Import failed. Please try again.',
  'pages.system.user.resetPwdTitle': 'Reset password?',
  'pages.system.user.resetPwdContent': 'Reset password for "{name}"?',
  'pages.system.user.resetPwdOk': 'Reset',
  'pages.system.user.resetPwdSuccess': 'Password reset',
  'pages.system.user.resetPwdFail': 'Password reset failed',
  'pages.system.user.resetPwdFailRetry': 'Password reset failed. Please try again.',

  'pages.system.user.col.nickname': 'Nickname',
  'pages.system.user.ph.nickname': 'Search by nickname',
  'pages.system.user.col.gender': 'Gender',
  'pages.system.user.gender.male': 'Male',
  'pages.system.user.gender.female': 'Female',
  'pages.system.user.gender.unknown': 'Unknown',
  'pages.system.user.col.roles': 'Roles',
  'pages.system.user.unassigned': 'Unassigned',
  'pages.system.user.col.organization': 'Organization',
  'pages.system.user.ph.organization': 'Select organization',
  'pages.system.user.col.dept': 'Department',
  'pages.system.user.ph.dept': 'Select department',
  'pages.system.user.col.status': 'Status',
  'pages.system.user.col.createTime': 'Created at',
  'pages.system.user.col.action': 'Actions',
  'pages.system.user.action.edit': 'Edit',
  'pages.system.user.action.resetPwd': 'Reset password',
  'pages.system.user.action.delete': 'Delete',
  'pages.system.user.exportTemplate': 'Export template',
  'pages.system.user.import': 'Import',
  'pages.system.user.addUser': 'Add user',
  'pages.system.user.deleteSuccess': 'Deleted',
  'pages.system.user.deleteFail': 'Delete failed',
  'pages.system.user.confirmToggleTitle': 'Confirm {action}',
  'pages.system.user.confirmToggleContent': 'Are you sure you want to {action} this user?',
  'pages.system.user.userNamed': 'User "{name}"',
  'pages.system.user.userBracketNamed': 'User [{name}]',
  'pages.system.user.batchUsers': '{count} selected user(s)',
  'pages.system.user.deleteBatchSuccess': 'Deleted {count} user(s)',
  'pages.system.user.resetPwdContentInitial':
    'Reset this user’s password to the initial password?',
  'pages.system.user.tableSelected': '{count} selected',
  'pages.system.user.batchDeleteWithCount': 'Batch delete ({count})',
  'pages.system.user.cancelSelection': 'Clear selection',
  'pages.system.user.importModalTitle': 'Import users',
  'pages.system.user.importProcessingFile': 'Processing file…',
  'pages.system.user.importDragText': 'Click or drag a file here to upload',
  'pages.system.user.importFileHintLong':
    'Single Excel file: .xlsx or .xls, up to 10MB',
  'pages.system.user.importRunning': 'Importing users…',
  'pages.system.user.importRunningHint': 'Please wait; results will appear when done',
  'pages.system.user.importInstructionsTitle': 'Import notes',
  'pages.system.user.importInstruction1': 'Download the template and fill users as required',
  'pages.system.user.importInstruction2': 'Required: username, name, email, phone',
  'pages.system.user.importInstruction3': 'Gender: male/female/unknown or 1/2/3',
  'pages.system.user.importInstruction4': 'Use correct role and organization names',
  'pages.system.user.importInstruction5': 'On errors, a failure file may be available to download',
  'pages.system.user.deptUnnamed': 'Unnamed department',
};
